import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.e6p_1 = partyId;
        this.f6p_1 = name;
        this.g6p_1 = email;
        this.h6p_1 = pairingRule;
        this.i6p_1 = badgesEnabled;
        this.j6p_1 = defaultBadgeName;
        this.k6p_1 = alternateBadgeName;
        this.l6p_1 = callSignsEnabled;
        this.m6p_1 = animationsEnabled;
        this.n6p_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.e6p_1.toString() + ', name=' + toString(this.f6p_1) + ', email=' + toString(this.g6p_1) + ', pairingRule=' + toString(this.h6p_1) + ', badgesEnabled=' + toString(this.i6p_1) + ', defaultBadgeName=' + toString(this.j6p_1) + ', alternateBadgeName=' + toString(this.k6p_1) + ', callSignsEnabled=' + toString(this.l6p_1) + ', animationsEnabled=' + toString(this.m6p_1) + ', animationSpeed=' + toString(this.n6p_1) + ')';
      }
      hashCode() {
        var result = this.e6p_1.hashCode();
        result = imul(result, 31) + hashCode(this.f6p_1) | 0;
        result = imul(result, 31) + hashCode(this.g6p_1) | 0;
        result = imul(result, 31) + hashCode(this.h6p_1) | 0;
        result = imul(result, 31) + hashCode(this.i6p_1) | 0;
        result = imul(result, 31) + hashCode(this.j6p_1) | 0;
        result = imul(result, 31) + hashCode(this.k6p_1) | 0;
        result = imul(result, 31) + hashCode(this.l6p_1) | 0;
        result = imul(result, 31) + hashCode(this.m6p_1) | 0;
        result = imul(result, 31) + hashCode(this.n6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.e6p_1.equals(other.e6p_1))
          return false;
        if (!equals(this.f6p_1, other.f6p_1))
          return false;
        if (!equals(this.g6p_1, other.g6p_1))
          return false;
        if (!equals(this.h6p_1, other.h6p_1))
          return false;
        if (!equals(this.i6p_1, other.i6p_1))
          return false;
        if (!equals(this.j6p_1, other.j6p_1))
          return false;
        if (!equals(this.k6p_1, other.k6p_1))
          return false;
        if (!equals(this.l6p_1, other.l6p_1))
          return false;
        if (!equals(this.m6p_1, other.m6p_1))
          return false;
        if (!equals(this.n6p_1, other.n6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
